import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NavBar from './components/NavBar';
import Home from './pages/Home';
import Projects from './pages/Projects';

import CheeseToastGame from './pages/projects/CheeseToastGame/CheeseToastGame';
import ComputerGraphicsProjects from './pages/projects/ComputerGraphicsProjects/ComputerGraphicsProjects';
import ComputerVisionProjects from './pages/projects/ComputerVisionProjects/ComputerVisionProjects';
import CubeAquarium from './pages/projects/CubeAquarium/CubeAquarium';
import DanceDanceFish from './pages/projects/DanceDanceFish/DanceDanceFish';
import DoubleUseBags from './pages/projects/DoubleUseBags/DoubleUseBags';
import Glowing from './pages/projects/Glowing/Glowing';
import JIPCAD from './pages/projects/JIPCAD/JIPCAD';
import MarimoMusic from './pages/projects/MarimoMusic/MarimoMusic';
import MrEgg from './pages/projects/MrEgg/MrEgg';
import OldFriend from './pages/projects/OldFriend/OldFriend';
import ToyBox from './pages/projects/ToyBox/ToyBox';
import WhackAMole from './pages/projects/WhackAMole/WhackAMole';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />

        <Route path="/projects/CheeseToastGame" element={<CheeseToastGame />} /> 
        <Route path="/projects/ComputerGraphicsProjects" element={<ComputerGraphicsProjects />} /> 
        <Route path="/projects/ComputerVisionProjects" element={<ComputerVisionProjects />} /> 
        <Route path="/projects/CubeAquarium" element={<CubeAquarium />} /> 
        <Route path="/projects/DanceDanceFish" element={<DanceDanceFish />} /> 
        <Route path="/projects/DoubleUseBags" element={<DoubleUseBags />} /> 
        <Route path="/projects/Glowing" element={<Glowing />} /> 
        <Route path="/projects/JIPCAD" element={<JIPCAD />} /> 
        <Route path="/projects/MarimoMusic" element={<MarimoMusic />} /> 
        <Route path="/projects/MrEgg" element={<MrEgg />} /> 
        <Route path="/projects/OldFriend" element={<OldFriend />} /> 
        <Route path="/projects/ToyBox" element={<ToyBox />} /> 
        <Route path="/projects/WhackAMole" element={<WhackAMole />} /> 

      </Routes>
    </BrowserRouter>
  );
};

export default App;
